import { createAuthGuard } from '@auth0/auth0-vue';
import { defineNuxtRouteMiddleware, useNuxtApp, navigateTo } from '#imports';
import type { RouteLocationNormalized } from 'vue-router';
import { AUTH } from '@/constants/common';

export default defineNuxtRouteMiddleware(async (to: RouteLocationNormalized) => {
  /* v8 ignore start -- SPA (ssr: false) では import.meta.server は静的に false となり true 分岐へ到達不能 */
  if (import.meta.server) return;
  /* v8 ignore stop */
  if (to.path.split('/').includes('auth')) return;

  const { vueApp } = useNuxtApp();
  const isAuthenticated = await createAuthGuard(vueApp)(to);
  if (!isAuthenticated) {
    return navigateTo(AUTH.REDIRECT.LOGIN);
  }
});
